<template>
  <header v-if="hideTopStrip">
    <XsHomeHeader
      ref="xsHomeHeader"
      v-if="$route.name === 'home' && !isCarousel && !rewardsFormat"
    />
    <XsHomeCarouselHeader
      ref="xsHomeHeader"
      v-if="$route.name === 'home' && (isCarousel || rewardsFormat)"
    />
    <XsStandardHeader
      v-if="fixXsStandardNavigation || $route.name !== 'home'"
    />
    <XsNavigation
      :fix="fixXsStandardNavigation || $route.name !== 'home'"
      :navTabs="navTabs"
    />
  </header>
</template>

<script>
import XsHomeHeader from "@/components/Header/Xs/HomeHeader.vue";
import XsNavigation from "@/components/Navigation/Xs/Navigation.vue";
import XsStandardHeader from "@/components/Header/Xs/StandardHeader.vue";
import { mapGetters, mapState } from "vuex";
import XsHomeCarouselHeader from "@/components/Header/Xs/HomeCarouselHeader.vue";

export default {
  name: "XsHeader",
  components: {
    XsHomeCarouselHeader,
    XsHomeHeader,
    XsNavigation,
    XsStandardHeader,
  },
  computed: {
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    ...mapState({
      isCarousel: (state) =>
        state.store.info.store_info.customization?.website.banner.isCarousel,
    }),
    hideTopStrip() {
      const routes = ["search", "confirmed"];
      return !routes.includes(this.$route.name);
    },
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      fixXsStandardNavigation: false,
    };
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const heightInPixelsOfXsStandardHeader = 134.67;
      const xsHomeHeaderBottomPos =
        this.$refs.xsHomeHeader &&
        this.$refs.xsHomeHeader.$el.getBoundingClientRect().bottom;
      this.fixXsStandardNavigation =
        xsHomeHeaderBottomPos < heightInPixelsOfXsStandardHeader;
    },
  },
  props: { navTabs: Array },
};
</script>
